import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Table, Loader} from 'semantic-ui-react';
import moment from 'moment';
import {Actions} from '../../../common/actions';
import YearLimit from './yearLimit';

class HistoricValues extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.handleAddLimit = this.handleAddLimit.bind(this);
  }

  handleAddLimit() {
    this.props.addProviderOrderLimit();
  }

  renderBody() {
    const {loading, saving, historicLimits} = this.props;

    if (loading || saving) {
      return (
        <Table.Row>
          <Table.Cell colSpan='100%'>
            <Loader active inline='centered'>
              Consultando...
            </Loader>
          </Table.Cell>
        </Table.Row>
      );
    }

    return historicLimits.map((element) => {
      return <YearLimit values={element} key={element.year} />;
    });
  }

  renderAddRegister() {
    const {historicLimits, loading, saving} = this.props;
    const date = moment();
    const isFullRegistered = historicLimits.find(
      (limit) => limit.year === date.year() + 1
    );

    if (isFullRegistered || loading || saving) {
      return null;
    }

    return (
      <Card.Content>
        <Card.Header className="add-register" onClick={this.handleAddLimit}>
          + AGREGAR REGISTRO
        </Card.Header>
      </Card.Content>
    );
  }

  render() {
    return (
      <Card raised fluid className='orders-historic-limits'>
        {this.renderAddRegister()}
        <div className='scroll-container'>
          <Table>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell textAlign='center'>Año</Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>
                  Monto Anual
                </Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>
                  Monto Consumido
                </Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>Progreso</Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>Acciones</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>{this.renderBody()}</Table.Body>
          </Table>
        </div>
      </Card>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.providerOrdersControl.loadingHistory,
    'saving': state.providerOrdersControl.saving,
    'historicLimits': state.providerOrdersControl.historicLimits,
  };
};

const {addMessageBoxError, addProviderOrderLimit} = Actions;

export default connect(mapStateToProps, {
  addMessageBoxError,
  addProviderOrderLimit,
})(HistoricValues);
